import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export var OrderMethod;
(function (OrderMethod) {
    OrderMethod["FromBasis"] = "FROM_BASIS";
    OrderMethod["Normal"] = "NORMAL";
    OrderMethod["Permanent"] = "PERMANENT";
})(OrderMethod || (OrderMethod = {}));
export const QueryFragmentDoc = gql `
    fragment Query on Query {
  ping
}
    `;
export const LoginDocument = gql `
    mutation Login($input: UserAuth!) {
  login(input: $input)
}
    `;
export function useLoginMutation(baseOptions) {
    return Apollo.useMutation(LoginDocument, baseOptions);
}
//# sourceMappingURL=graphql.js.map